export default __webpack_public_path__ + "static/media/FGS.3f4c5397.svg";